import reactComponentManager from 'utils/reactComponentManager';
import domContentLoaded from 'utils/domContentLoaded';
import VideoCarousel from 'components/video-carousel-jw/index.tsx';
import VideoPlayer from 'nbc-station/client/src/components/nbc-jw-player';
import { checkForAnalytics } from 'nbc-station/client/src/components/nbc-jw-player/utils';

import './index.scss';

checkForAnalytics();

domContentLoaded(() => {
  document.addEventListener('sObjectLoaded', () => {
    reactComponentManager({
      VideoCarousel,
      VideoPlayer,
    });
  });
});
